import { Fragment } from 'react'

import { FlexBox } from '../../../components/Base/FlexBox'
import { Text } from '../../../components/Text/Text'
import { ProductSubscriptionItemStatus } from '../../../models/productSubscription'
import { SlimTeam } from '../../../models/team'
import { midGray } from '../../../theme/colors'

interface TeamEntitlementsProps {
  team: SlimTeam
  isInsideSidebar?: boolean
}

export function TeamEntitlements({ team, isInsideSidebar }: TeamEntitlementsProps) {
  const entitlements = team?.entitlements || []
  const sortedEntitlements = [...entitlements].sort((e) =>
    e.status === ProductSubscriptionItemStatus.ACTIVE ? -1 : 1
  )

  if (!sortedEntitlements.length) return null

  if (team.carrier) {
    if (isInsideSidebar) {
      return (
        <Text variant="header4" fontColor={midGray}>
          {team.carrier.name} MC {team.carrier.mcNumber}
        </Text>
      )
    }

    return (
      <>
        ({team.carrier.name} - {team.carrier.mcNumber})
      </>
    )
  }

  if (isInsideSidebar) {
    return (
      <FlexBox alignItems="center" gap="3px">
        <Text variant="header4" fontColor={midGray}>
          {sortedEntitlements.map((entitlement) => (
            <Fragment key={entitlement.name}>{entitlement.name}</Fragment>
          ))}
        </Text>
      </FlexBox>
    )
  }

  return (
    <FlexBox alignItems="center" gap="3px">
      (
      {sortedEntitlements.map((entitlement) => (
        <Fragment key={entitlement.name}>{entitlement.name}</Fragment>
      ))}
      )
    </FlexBox>
  )
}
